import React, { useEffect, useState } from "react";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import BackMethods from "../../back_component/BackMethods";
import { FaCalendarPlus, FaUserShield, FaUsers, FaClipboardList, FaSave, FaArrowRight } from "react-icons/fa";

const PatrolRosterCreatePage = () => {
    const navigate = useNavigate();
    const { backEnd_request } = BackMethods();

    const [users, setUsers] = useState([]);
    const [staff, setStaff] = useState([]);
    const [loading, setLoading] = useState(false);

    const [userId, setUserId] = useState(null);
    const [patrolDate, setPatrolDate] = useState("");
    const [leaderStaffId, setLeaderStaffId] = useState(null);
    const [memberStaffIds, setMemberStaffIds] = useState([]);
    const [notes, setNotes] = useState("");

    const fetchUsers = async () => {
        try {
            const res = await backEnd_request.get("/admin/UsersManagement");
            setUsers(res.data.users.map((u) => ({
                value: u.userId,
                label: u.username
            })));
        } catch (error) {
            console.error("Error loading users:", error);
        }
    };

    const fetchStaff = async () => {
        try {
            const res = await backEnd_request.get("/PatrolStaff");
            setStaff(res.data.map((s) => ({
                value: s.patrolStaffId,
                label: `${s.firstName} ${s.lastName} (${s.departmentName})`
            })));
        } catch (error) {
            console.error("Error loading staff:", error);
        }
    };

    useEffect(() => {
        fetchUsers();
        fetchStaff();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!userId) return alert("الرجاء اختيار المستخدم المسؤول");
        if (!leaderStaffId) return alert("يجب اختيار رئيس الدورية!");
        if (memberStaffIds.length === 0) return alert("يجب اختيار عضو واحد على الأقل!");

        setLoading(true);
        const payload = {
            userId,
            patrolDate,
            leaderStaffId,
            memberStaffIds: memberStaffIds.map((s) => s.value),
            notes,
        };

        try {
            await backEnd_request.post("/PatrolRosters", payload);
            navigate("/admin/patrol-rosters");
        } catch (error) {
            console.error("Error saving roster:", error);
            alert("حدث خطأ أثناء حفظ الدورية");
        } finally {
            setLoading(false);
        }
    };

    // تنسيق مخصص لـ React-Select ليناسب Bootstrap
    const customSelectStyles = {
        control: (base) => ({
            ...base,
            padding: '2px',
            borderRadius: '8px',
            borderColor: '#dee2e6',
            boxShadow: 'none',
            '&:hover': { borderColor: '#0d6efd' }
        })
    };

    return (
        <div className="container py-5" dir="rtl">
            {/* Header */}
            <div className="d-flex justify-content-between align-items-center mb-4">
                <div>
                    <h2 className="fw-bold text-dark mb-1">
                        <FaCalendarPlus className="ms-2 text-primary" /> إنشاء دورية جديدة
                    </h2>
                    <p className="text-muted small">قم بتعبئة البيانات لتخصيص طاقم الدورية اليومي</p>
                </div>
                <button className="btn btn-outline-secondary btn-sm rounded-pill px-3" onClick={() => navigate(-1)}>
                    <FaArrowRight className="ms-1" /> رجوع
                </button>
            </div>

            <div className="card border-0 shadow-sm rounded-4">
                <div className="card-body p-4 p-md-5">
                    <form onSubmit={handleSubmit}>

                        <div className="row g-4">
                            {/* المسؤول عن السجل */}
                            <div className="col-md-6">
                                <label className="form-label fw-bold"><FaUserShield className="ms-1 text-primary" /> المستخدم المسؤول (Admin)</label>
                                <Select
                                    options={users}
                                    styles={customSelectStyles}
                                    placeholder="ابحث عن مستخدم..."
                                    onChange={(e) => setUserId(e.value)}
                                    isSearchable
                                />
                            </div>

                            {/* تاريخ الدورية */}
                            <div className="col-md-6">
                                <label className="form-label fw-bold"><FaClipboardList className="ms-1 text-primary" /> تاريخ الدورية</label>
                                <input
                                    type="date"
                                    className="form-control form-control-lg fs-6 rounded-3"
                                    value={patrolDate}
                                    onChange={(e) => setPatrolDate(e.target.value)}
                                    required
                                />
                            </div>

                            {/* رئيس الدورية */}
                            <div className="col-md-6">
                                <label className="form-label fw-bold text-warning"><FaStar className="ms-1" /> رئيس الدورية (القائد)</label>
                                <Select
                                    options={staff}
                                    styles={customSelectStyles}
                                    placeholder="اختر قائد الدورية..."
                                    onChange={(e) => setLeaderStaffId(e.value)}
                                    isSearchable
                                />
                            </div>

                            {/* أعضاء الدورية */}
                            <div className="col-md-6">
                                <label className="form-label fw-bold"><FaUsers className="ms-1 text-primary" /> أعضاء الدورية</label>
                                <Select
                                    options={staff}
                                    styles={customSelectStyles}
                                    placeholder="اختر الأعضاء المرافقين..."
                                    onChange={(selected) => setMemberStaffIds(selected)}
                                    isMulti
                                    isSearchable
                                />
                            </div>

                            {/* الملاحظات */}
                            <div className="col-12">
                                <label className="form-label fw-bold">ملاحظات إضافية</label>
                                <textarea
                                    className="form-control rounded-3"
                                    rows={4}
                                    placeholder="اكتب أي تعليمات أو ملاحظات خاصة بالدورية هنا..."
                                    value={notes}
                                    onChange={(e) => setNotes(e.target.value)}
                                ></textarea>
                            </div>

                            {/* أزرار التحكم */}
                            <div className="col-12 mt-5">
                                <div className="d-grid d-md-flex justify-content-md-end gap-3">
                                    <button
                                        type="button"
                                        className="btn btn-light btn-lg px-5 rounded-3 fw-bold"
                                        onClick={() => navigate("/admin/patrol-rosters")}
                                    >
                                        إلغاء
                                    </button>
                                    <button
                                        type="submit"
                                        className="btn btn-primary btn-lg px-5 rounded-3 fw-bold shadow"
                                        disabled={loading}
                                    >
                                        {loading ? (
                                            <span className="spinner-border spinner-border-sm me-2"></span>
                                        ) : (
                                            <FaSave className="ms-2" />
                                        )}
                                        حفظ وإرسال
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

// أيقونة النجمة البسيطة لرئيس الدورية
const FaStar = ({ className }) => (
    <svg className={className} stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 576 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
        <path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path>
    </svg>
);

export default PatrolRosterCreatePage;